exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unassigned-devices{padding:10px}.unassigned-devices .device-details{margin-bottom:10px}", ""]);

// exports
